export enum WelcomeFormFields {
    DESCRIBE_YOURSELF = "describeYourself",
    PROSPECTION_SKILL = "prospectionSkill",
    MAIN_GOAL = "mainGoal",
    HEARD_ABOUT_US = "heardAboutUs",
}

export enum WelcomeFormFieldsHeardAboutUsOptions {
    ADS = "ads",
    SOCIAL = "social",
    MOUTH = "mouth",
    INTERNET = "internet",
    FORGET = "forget",
    AMBASSADOR = "ambassador",
}

export enum WelcomeFormFieldsMainGoalOptions {
    EXPAND = "expand",
    FIND = "find",
    HIRE = "hire",
}

export enum WelcomeFormFieldsDescribeYourselfOptions {
    MARKETING = "marketing",
    SALES = "sales",
    FREELANCE = "freelance",
    RECRUITER = "recruiter",
    FOUNDER = "founder",
    STUDENT = "student",
}

export enum WelcomeFormFieldsProspectionSkillOptions {
    NEVER = "never",
    ALREADY = "already",
    CONFORTABLE = "confortable",
}

export enum WelcomeFormFieldsOtherOption {
    OTHER = "other",
}

export enum AdminActionsType {
    BAN = "ban",
    UNBAN = "unban",
}

export enum OnboardingType {
    STANDARD = "standard",
    FORM_ONLY = "form_only",
    DIRECT = "direct",
}

export enum OnboardingQuestion {
    USER_ROLE = "userRole",
    MAIN_OBJECTIVE = "mainObjective",
    PREVIOUS_TOOL_EXPERIENCE = "previousToolExperience",
    DISCOVERY_SOURCE = "discoverySource",
}

export const isOnboardingQuestion = (question: string): question is OnboardingQuestion => {
    const onboardingQuestions = Object.values(OnboardingQuestion) as string[];
    return onboardingQuestions.includes(question);
};

export enum ActionByHacker {
    CREATED_BY_HACKER = "created_by_hacker",
    UPDATED_BY_HACKER = "updated_by_hacker",
}
